import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoPremioView.
 * @extends JetView
 */
export default class FilterPagoPremioView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input field for ticket number
                            name: 'NoTicket',
                            type: 'number',
                            label: "<span class='icon-ticket'></span>" + _('No. Ticket'),
                            labelPosition: 'top',
                            placeholder: _('No. Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for invalid input
                        },
                        {
                            view: 'text', // Input field for ticket key
                            name: 'ClaveTicket',
                            type: 'password',
                            label: "<span class='icon-ticket1'></span>" + _('Clave Ticket'),
                            labelPosition: 'top',
                            placeholder: _('Clave Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for invalid input
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity element for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };
        const datos = {
            // Sample data for display
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clear form fields
                                $$('formPagoPremio').hide(); // Hide form
                                $$('tablePagoPremio').hide(); // Hide table
                            },
                        },
                        {
                            view: 'button', // Button to consult data
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                if (this.getRoot().validate()) {
                                    // Validate form
                                    const filterdata = this.getRoot().getValues(); // Get form values
                                    this.app.callEvent('pagoPremio:filter', [
                                        filterdata, // Trigger filter event
                                    ]);
                                    const vthis = this; // Preserve context
                                    webix
                                        .ajax() // AJAX request to fetch data
                                        .get(
                                            devConfig.geturlApi() + '/Machine/GetPagoPremio',
                                            'NoTicket=' +
                                                filterdata.NoTicket +
                                                '&ClaveTicket=' +
                                                filterdata.ClaveTicket,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handling
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handling
                                                    text = JSON.parse(text); // Parse response
                                                    vthis.app.callEvent(
                                                        'pagoPremio:data',
                                                        [text.data], // Trigger data event
                                                    );
                                                    $$('formPagoPremio').show(); // Show form
                                                    $$('tablePagoPremio').show(); // Show table
                                                    $$('pagerA').show(); // Show pager
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [upper_section, buttons], // Layout structure
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Change event for validation
                        this.validate(); // Validate input on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when webix is ready
            if (screen.width < 500) {
                // Check screen width
                $$('grav').hide(); // Hide gravity element if screen is small
                $$('grav2').hide(); // Hide gravity element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
